import React from 'react';
import {ArrowUpRight} from 'lucide-react';
import './EventNotificationContent.css';

export default function EventNotificationContent({message = '', url, cancelled = false, onNavigate, children}) {
  const clarification = 'You are not a participant in this event.';
  const nonParticipant = message.includes(clarification);
  const details = nonParticipant ? message.replace(clarification, '').trim() : message;
  const navigationLabel = cancelled ? 'Open calendar' : 'Open event';
  return <div className="event-notification">
    <div className="event-notification__heading">
      <strong>🔔 Valovate.com Notification</strong>
      {url && <a href={url} title={navigationLabel} aria-label={navigationLabel}
        onClick={event => {event.stopPropagation(); if (onNavigate) {event.preventDefault(); onNavigate(url);}}}>
        <ArrowUpRight size={17} aria-hidden="true"/>
      </a>}
    </div>
    {nonParticipant && <strong className="event-notification__notice">{clarification}</strong>}
    <span className="notification-message">{details}</span>
    {children}
  </div>;
}
